import { React } from "react";
import useAxios from "../../../../utilities/useAxios";
import PageTitle from "../../../PageTitle";
import { Form, Input, Button, Card, message } from "antd";

const AddEtarCar = () => {
	const [form] = Form.useForm();

	const onFinish = async (values) => {
		try {
			const response = await useAxios.post("/utils/etal-car/", {
				inst: values.inst || "",
				car_num: values.car_num,
				owner: values.owner,
			});

			if (response.status === 201) {
				message.success("차량이 성공적으로 등록되었습니다.");
				if (window.opener && window.opener.refreshEtarCars) {
					window.opener.refreshEtarCars();
				}
				window.close();
			}
		} catch (error) {
			message.error(
				error.response?.data?.message ||
					"차량 등록 중 오류가 발생했습니다."
			);
		}
	};

	return (
		<>
			<PageTitle title="이탈 차량 등록" />
			<div className="utils-accessed_car__container">
				<div className="utils-accessed_car__header">
					<h1 className="utils-accessed_car__header__title">
						이탈 차량 등록
					</h1>
				</div>
				<div className="utils-accessed_car__content-container">
					<Card className="utils-accessed_car__form-card">
						<Form
							form={form}
							layout="vertical"
							onFinish={onFinish}
							autoComplete="off">
							<Form.Item label="소속" name="inst">
								<Input placeholder="소속을 입력하세요" />
							</Form.Item>

							<Form.Item
								label="차량번호"
								name="car_num"
								rules={[
									{
										required: true,
										message: "차량번호를 입력해주세요",
									},
								]}>
								<Input placeholder="차량번호를 입력하세요" />
							</Form.Item>

							<Form.Item
								label="차주"
								name="owner"
								rules={[
									{
										required: true,
										message: "차주를 입력해주세요",
									},
								]}>
								<Input placeholder="차주 이름을 입력하세요" />
							</Form.Item>

							<Form.Item>
								<div className="utils-accessed_car__form-actions">
									<Button type="primary" htmlType="submit">
										추가
									</Button>
									<Button onClick={() => window.close()}>
										취소
									</Button>
								</div>
							</Form.Item>
						</Form>
					</Card>
				</div>
			</div>
		</>
	);
};

export default AddEtarCar;
